export const donorConstants = {
    // Add and editing donor
    SAVING_DONOR_REQUEST: 'SAVING_DONOR_REQUEST',
    SAVING_DONOR_SUCCESS: 'SAVING_DONOR_SUCCESS',
    SAVING_DONOR_FAILURE: 'SAVING_DONOR_FAILURE',

    // Loading donors
    LOAD_DONORS_REQUEST: 'LOAD_DONORS_REQUEST',
    LOAD_DONORS_SUCCESS: 'LOAD_DONORS_SUCCESS',
    LOAD_DONORS_FAILURE: 'LOAD_DONORS_FAILURE',

    // Delete donor
    DELETE_DONOR_REQUEST: 'DELETE_DONOR_REQUEST',
    DELETE_DONOR_SUCCESS: 'DELETE_DONOR_SUCCESS',
    DELETE_DONOR_FAILURE: 'DELETE_DONOR_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/donor.constants.js